export const lightTheme = {
  background: "#ffffff",
  text: "#000000",
  card: "#f5f5f5",
  button: "#3498db",
  buttonText: "#ffffff",
};

export const darkTheme = {
  background: "#1e1e1e",
  text: "#ffffff",
  card: "#2c2c2c",
  button: "#e74c3c",
  buttonText: "#ffffff",
};
